import React, { useImperativeHandle, useEffect, useState, useMemo } from 'react';
import { message, Select } from 'antd';
import courseFormUtils from '../../pages/CourseEditPage/courseFormUtils';
import useSyncObjectRelationships from '../../gql/hooks/useSyncObjectRelationships';
import useGroups from '../../gql/hooks/useGroups';
import './styles.less';

const FormLearningProfiles = ( { form, modifiedCallback, ref } ) => {
    const [ learningProfileIds, setLearningProfileIds ] = useState( [] );
    const [ sync ] = useSyncObjectRelationships();
    const { groups, groupsLoading, groupsError } = useGroups();
    
    useImperativeHandle( ref, () => ( {
        reset() {
            reset();
        },
        isModified() {
            return form.getFieldValue( 'learningProfileIdsAreModified' );
        },
        async syncData() {
            const syncData = courseFormUtils.getLearningProfileSyncValues( form );
            
            if ( syncData ) {
                try {
                    await sync( { variables: { input: syncData } } );
                    courseFormUtils.updateLearningProfileValues( form, syncData.relatedResourceIds );
                    reset();
                    return true;
                } catch ( error ) { 
                    console.error( 'Error saving!', error );  
                    message.error( 'Error saving!' );  
                    return false;
                } 
            }
        }
    } ) );
     
    const reset = () => {
        form.setFieldsValue( { learningProfileIdsAreModified: false } ); 
        form.setFieldsValue( { learningProfileIdsModified: [] } ); 
        setLearningProfileIds( form.getFieldValue( 'learningProfileIds' ) );
        modifiedCallback( false ); 
    };

    const listData = useMemo( () => { 
        return groups.filter( i => {
            return i.attributes.find( a => a.name === 'lms-learning-profile' );
        } );
    }, [ groups ] );

    useEffect( () => listData && setLearningProfileIds( form.getFieldValue( 'learningProfileIds' ) ), 
        [ listData, setLearningProfileIds ] );

    const handleChangeIds = ( values ) => {
        setLearningProfileIds( values ); 

        if ( JSON.stringify( values ) !== JSON.stringify( form.getFieldValue( 'learningProfileIds' ) ) ) {
            form.setFieldsValue( { learningProfileIdsAreModified: true } ); 
            form.setFieldsValue( { learningProfileIdsModified: values } ); 
            modifiedCallback( true );
        } else {
            form.setFieldsValue( { learningProfileIdsAreModified: false } ); 
            form.setFieldsValue( { learningProfileIdsModified: [] } ); 
            modifiedCallback( false );
        }
    };

    return (
        <div className="form-item-learning-profiles">
            { !groupsLoading && !groupsError &&
                <>
                    <h4 style={ { marginBottom: '8px' } }>Learning Profiles</h4>
                    <Select
                        mode="multiple"
                        value={ learningProfileIds }
                        placeholder="Select" 
                        onChange={ handleChangeIds }
                        filterOption={ ( input, option ) => 
                            ( option?.children ? 
                                option.children[ 0 ].type ? '' : option.children[ 0 ]
                                : '' ).toLowerCase().includes( input.toLowerCase() )
                        }
                    >
                        {
                            listData.map( i => {
                                return ( 
                                    <Select.Option 
                                        key={ i.id } 
                                        value={ i.id }  
                                    >
                                        { i.name || <span className='italic'>No Name</span> }
                                    </Select.Option>
                                );
                            } )
                        }
                    </Select>
                </>
            }
        </div>
    );
};

export default FormLearningProfiles;
